(() => {
  const updatePlayPauseButton = (video) => {
    const slide = video.closest('.video-slide');
    if (!slide) return;
    const playPauseBtn = slide.querySelector('.play-pause-btn');
    if (!playPauseBtn) return;

    if (video.paused) {
      playPauseBtn.classList.add('is-paused');
      playPauseBtn.classList.remove('is-playing');
    } else {
      playPauseBtn.classList.add('is-playing');
      playPauseBtn.classList.remove('is-paused');
    }
  };

  const initVideoControls = (scope) => {
    scope.querySelectorAll('.video-slide').forEach((slide) => {
      if (slide.dataset.videoControlsInit === 'true') return;
      slide.dataset.videoControlsInit = 'true';

      const video = slide.querySelector('.video-player');
      const controls = slide.querySelector('.custom-video-controls');
      if (!video || !controls) return;

      const playPauseBtn = controls.querySelector('.play-pause-btn');
      const progressContainer = controls.querySelector('.progress-container');
      const progressBar = controls.querySelector('.progress-bar');
      if (!playPauseBtn || !progressContainer || !progressBar) return;

      const togglePlay = () => {
        if (video.paused) {
          scope.querySelectorAll('.video-player').forEach((v) => {
            if (v !== video && !v.paused) {
              v.pause();
              updatePlayPauseButton(v);
            }
          });
          video.play();
        } else {
          video.pause();
        }
        updatePlayPauseButton(video);
      };

      // Bind toggle once on the controls wrapper. The play/pause button lives
      // inside .custom-video-controls, so its clicks bubble up here — binding it
      // separately too would fire togglePlay twice (play → instantly pause = no-op).
      controls.addEventListener('click', togglePlay);

      video.addEventListener('timeupdate', () => {
        if (!video.duration) return;
        progressBar.style.width = `${(video.currentTime / video.duration) * 100}%`;
      });

      progressContainer.addEventListener('click', (e) => {
        // Seek only — don't let the click bubble to controls and toggle playback.
        e.stopPropagation();
        if (!video.duration) return;
        const rect = progressContainer.getBoundingClientRect();
        const pos = (e.clientX - rect.left) / rect.width;
        video.currentTime = pos * video.duration;
      });

      video.addEventListener('ended', () => updatePlayPauseButton(video));
    });
  };

  const initProductVideoSlider = (root) => {
    const scope = root || document;
    const slider = scope.querySelector('.product-info__video-slider');
    if (!slider) return;

    const swiperEl = slider.querySelector('.video-swiper');
    if (!swiperEl) return;

    if (typeof Swiper === 'undefined') {
      setTimeout(() => initProductVideoSlider(root), 100);
      return;
    }

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    slider.querySelectorAll('.video-slide').forEach((slide) => {
      slide.removeAttribute('data-video-controls-init');
    });

    new Swiper(swiperEl, {
      slidesPerView: 1.85,
      spaceBetween: 8,
      breakpoints: {
        699: {
          slidesPerView: 2.15,
        },
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-btn--next'),
        prevEl: slider.querySelector('.swiper-btn--prev'),
      },
      scrollbar: {
        el: slider.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      on: {
        slideChange() {
          slider.querySelectorAll('.video-player').forEach((video) => {
            if (!video.paused) {
              video.pause();
              updatePlayPauseButton(video);
            }
          });
        },
      },
    });

    initVideoControls(slider);
  };

  window.initProductVideoSlider = initProductVideoSlider;

  const boot = () => initProductVideoSlider(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
